export var getInteractiveModalMapConfig = function getInteractiveModalMapConfig(config) {
  if (config && config.length === 0) {
    return false;
  } else {
    return config;
  }
};